import React from 'react';
import FeatureCard from '../FeatureCard';
import { RefreshCcw, Server, Shield, Headphones, DollarSign, BarChart } from 'lucide-react';

const features = [
  {
    title: "Continuous RL Optimization",
    description: "GRPO‑powered feedback loops keep your models learning from fresh production data so accuracy improves every release—no rebuilds required.",
    icon: RefreshCcw
  },
  {
    title: "On‑Prem & VPC Deployment",
    description: "Run the full OpenPipe stack inside your private cloud or data center; zero customer data or model weights ever leave your network.",
    icon: Server
  },
  {
    title: "Regulatory Compliance & Governance",
    description: "SOC 2 Type II, HIPAA, and GDPR support, plus role‑based access controls and immutable audit logs, satisfy the strictest InfoSec reviews.",
    icon: Shield
  },
  {
    title: "Dedicated Support & Contractual SLAs",
    description: "Named solution architects, SLAs, and roadmap influence are written directly into your enterprise agreement.",
    icon: Headphones
  },
  {
    title: "Predictable Enterprise Economics",
    description: "Up to 8× lower inference cost than GPT‑4‑class APIs, with volume discounts and optional fixed‑fee tiers for budget certainty.",
    icon: DollarSign
  },
  {
    title: "Unified Observability & Evaluation Hub",
    description: "Live dashboards, automated guardrails, and approval workflows make it easy to prove alignment and catch regressions before they reach production.",
    icon: BarChart
  }
];

const HomeFeatures = () => {
  return (
    <section>
      <div className="text-center max-w-3xl mx-auto">
        <h2 className="text-3xl font-bold mb-4">Key Features</h2>
        <p className="text-muted-foreground max-w-2xl mx-auto">
          Evaluate, fine-tune, and serve LLMs with a seamless developer experience.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {features.map((feature, index) => (
          <div key={index}>
            <FeatureCard
              title={feature.title}
              description={feature.description}
              icon={feature.icon}
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default HomeFeatures;
